const getClientTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone;

export default getClientTimeZone;
